"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Label = function Label(_ref) {
  var className = _ref.className,
      children = _ref.children,
      additionalProps = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  var classes = (0, _classnames.default)('Label', className);
  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({
    className: classes
  }, additionalProps), children);
};

var _default = Label;
exports.default = _default;